import { z } from 'zod'
import { FireOutbreakOccurrenceEnum } from '../../../domain/enum/FireOutbreakOccurence.enum'
import { FireOutbreakReactionEnum } from '../../../domain/enum/FireOutbreakReaction.enum'
import { FireRiskEnum } from '../../../domain/enum/FireRisk.enum'
import { FireOutbreak } from '../../../domain/entities/FireOutbreak'

export const FireOutbreakSchema = z
	.object({
		hash_informacao: z.string(),
		momento_coleta_informacao: z.preprocess((value: string) => new Date(value), z.date()),
		momento_geracao_alerta: z.preprocess((value: string) => new Date(value), z.date()),
		nome_area_monitorada: z.string(),
		id_area_monitorada: z.uuid(),
		porcentagem_confianca: z.number(),
		nome_do_satelite: z.string(),
		radiancia: z.preprocess((value) => (value ? value : 0), z.number().optional()),
		detectado_no_buffer: z.preprocess(
			(value: boolean) =>
				value ? FireOutbreakOccurrenceEnum.BUFFER : FireOutbreakOccurrenceEnum.FARM,
			z.enum(FireOutbreakOccurrenceEnum),
		),
		latitude: z.number().min(-90).max(90),
		longitude: z.number().min(-90).max(90),
		grau_de_perigo: z.enum(FireRiskEnum),
		avaliacao_do_usuario: z.preprocess(
			(value: string) =>
				Object.values(FireOutbreakReactionEnum).includes(value as FireOutbreakReactionEnum)
					? (value as FireOutbreakOccurrenceEnum)
					: undefined,
			z.enum(FireOutbreakReactionEnum).optional(),
		),
	})
	.transform((data) => {
		return new FireOutbreak(
			data.hash_informacao,
			data.momento_coleta_informacao,
			data.momento_geracao_alerta,
			data.nome_area_monitorada,
			data.id_area_monitorada,
			Number(data.porcentagem_confianca.toFixed(2)),
			data.nome_do_satelite,
			data.detectado_no_buffer,
			data.grau_de_perigo,
			data.latitude,
			data.longitude,
			data.avaliacao_do_usuario,
			data.radiancia,
		)
	})
